import { createReduxModule } from "hooks-for-redux";
import { USE_PROD } from "../services/api";

const host = process.env.NEXT_PUBLIC_HOST;

const initialState = {
  ws: null,
  websocketUrl: null,
  longPollingUrl: null,
  reconnectStart: null,
  reconnectTime: null,
  pingTime: 0,
  pingReceived: true,
  pingStart: Date.now(),
  otherLoginShow: false,
  wsConnected: false,
};

const testPorts = {
  ws1: "9090",
  ws2: "9091",
  ws3: "9092",
};

export const [
  useWsConnection,
  {
    setWebsocketUrl,
    doStartReconnectTimer,
    updateReconnectTimer,
    endReconnectTimer,
    setOtherLoginShow,
    setWsConnected,
  },
  wsConnectionStore,
] = createReduxModule("wsConnection", initialState, {
  setWebsocketUrl: (state, ws) => {
    const serverInstance = "ws" + ws;
    const testPort = testPorts[serverInstance];
    const websocketUrl = USE_PROD
      ? `wss://${host}/${serverInstance}/`
      : `ws://${host}:${testPort}`;

    const longPollingUrl = USE_PROD
      ? `https://${host}/${serverInstance}/api`
      : `http://${host}:${testPort}/${serverInstance}/api`;

    return {
      ...state,
      ws,
      websocketUrl,
      longPollingUrl,
    };
  },
  doStartReconnectTimer: (state) => ({
    ...state,
    reconnectStart: Date.now(),
  }),
  updateReconnectTimer: (state) => ({
    ...state,
    reconnectTime: Date.now(),
  }),
  endReconnectTimer: (state) => ({
    ...state,
    reconnectStart: null,
    reconnectTime: null,
  }),
  setOtherLoginShow: (state, otherLoginShow) => ({
    ...state,
    otherLoginShow,
  }),
  setWsConnected: (state, wsConnected) => ({
    ...state,
    wsConnected,
  }),
});
